export default "__VITE_ASSET__C6KKdC8L__"